<template>
            <div class="m-menu__link timetrack">
                <button @click="timetrackingOpen= !timetrackingOpen;" class="btn btn-sm m-btn m-btn m-btn--icon m--margin-right-15" :class="{ 'btn-default': activeTimetracks.length == 0 }">
                    <i class="m-menu__link-icon la la-hourglass-end"></i>
                    <span class="m-menu__link-title">
                        <span class="m-menu__link-wrap">
                            <span class="m-menu__link-text">Timetracking</span>
                            <span class="m-menu__link-badge" v-if="activeTimetracks.length > 0"><span class="m-badge m-badge--danger">{{ activeTimetracks.length }}</span></span>
                        </span>
                    </span>
                </button>

                <div class="timetracking-modal" v-if="showFinishTimetrackItem">
                    <div class="timetracking-modal__headline">Timetrack speichern</div>
                    <form class="m-form m-form--fit m-form--label-align-right" _lpchecked="1">
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-form-label col-lg-3 col-sm-12">Zeit (hh:mm)</label>
                                <div class="col-lg-9 col-md-9 col-sm-12">
                                    <input class="form-control" type="text" name="count" v-model="finishTimetrackItem.count">
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-form-label col-lg-3 col-sm-12">Datum (tt.mm.yyyy)</label>
                                <div class="col-lg-9 col-md-9 col-sm-12">
                                    <input class="form-control" type="text" name="count" v-model="finishTimetrackItem.tracking_date">
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-form-label col-lg-3 col-sm-12">Kategorie</label>
                                <div class="col-lg-9 col-md-9 col-sm-12">
                                    <select class="form-control m-input m-input--square" id="timetrackArr" v-model="finishTimetrackItem.category_id">
                                        <option value="0">Bitte wählen</option>
                                        <option v-for="(category, key) in timetrackCategoryArr" :value="key">{{ category }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-form-label col-lg-3 col-sm-12">Notiz</label>
                                <div class="col-lg-9 col-md-9 col-sm-12">
                                    <textarea class="form-control m-input" v-model="finishTimetrackItem.note"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__foot m-portlet__foot--fit">
                            <div class="m-form__actions m-form__actions">
                                <div class="row">
                                    <div class="col-lg-9 ml-lg-auto">
                                        <button @click="saveFinishTimetrack()" type="button" class="btn btn-brand">Speichern</button>
                                        <button @click="showFinishTimetrackItem = false" type="button" class="btn btn-default">schließen</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="timetracking-modal" v-else-if="timetrackingOpen">
                    <div class="timetracking-modal__headline">Aktive TimeTracks</div>
                    <div class="timetracking-modal__item" v-for="timetrack in activeTimetracks">
                        <div class="timetracking-modal__name">
                            <a href="#" class="btn btn-secondary m-btn m-btn m-btn--icon m--margin-right-10"><span><i class="la la-user"></i><span>{{ timetrack.project.client_id }} - {{ timetrack.project.client_project_count }}</span></span></a> {{ timetrack.project.name }}</div>
                        <div class="timetracking-modal__button">
                            <div class="">
                                <button v-if="timetrack.start === null" @click="startTimetrack(timetrack.project.id)" class="btn btn-primary btn-sm m-btn m-btn m-btn--icon m--margin-right-15"><i class="la la-play"></i></button>
                                <button v-else @click="stopTimetrack(timetrack.project.id)" class="btn btn-danger btn-sm m-btn m-btn m-btn--icon m--margin-right-15"><i class="la la-times-circle-o"></i></button>
                                <span class="timetracking-modal__zeit">{{ timetrack.timeFormate }}</span>
                                <button @click="finishTimetrack(timetrack.id)" class="btn btn-success btn-sm m-btn m-btn m-btn--icon m--margin-left-15"><i class="la la-save"></i></button>
                            </div>
                        </div>
                        <div @click="deleteTimetrack(timetrack.id)" class="timetracking-modal__delete"><button class="btn btn-danger btn-sm m-btn m-btn m-btn--icon"><i class="la la-close"></i></button></div>
                    </div>
                </div>
            </div>

</template>
<script>
    export default {
        name: 'timetrack',
        props: {
            timetrackCategoryArr: Array
        },
        data() {
            return {
                timetrackingOpen: false,
                timetrackingActive: false,
                activeTimetracks: [],
                finishTimetrackItem: {},
                showFinishTimetrackItem: false
            }
        },
        mounted() {
            this.getUserTimetracks();
        },
        watch: {
            timetrackingOpen: function (val) {
                this.getUserTimetracks();
            }
        },
        methods: {
            getUserTimetracks(){
                let them = this;

                $.ajax({
                    url :'/get-timetracks-from-user',
                    type: "GET",
                    data: {},
                    success:  (data) => {
                        them.activeTimetracks = JSON.parse(data);
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },

            startTimetrack(projectId){
                let them = this;

                $.ajax({
                    url :'/start-ajax-timetracking-' + projectId,
                    type: "GET",
                    data: {},
                    success:  (data) => {
                        them.getUserTimetracks();
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },

            stopTimetrack(projectId){
                let them = this;

                $.ajax({
                    url :'/stop-ajax-timetracking-' + projectId,
                    type: "GET",
                    data: {},
                    success:  (data) => {
                        them.getUserTimetracks();
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },

            deleteTimetrack(timetrackId){
                let them = this;

                $.ajax({
                    url :'/delete-ajax-timetracking-' + timetrackId,
                    type: "GET",
                    data: {},
                    success:  (data) => {
                        them.getUserTimetracks();
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },
            finishTimetrack(timetrackId){
                let them = this;

                $.ajax({
                    url :'/get-timetrack-' + timetrackId,
                    type: "GET",
                    data: {},
                    success:  (data) => {
                        them.finishTimetrackItem = JSON.parse(data);
                        them.finishTimetrackItem.tracking_date = them.getNow();
                        them.showFinishTimetrackItem = true;
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },
            saveFinishTimetrack(){
                let them = this;

                $.ajax({
                    url :'/save-finish-timetrack',
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { item: them.finishTimetrackItem },
                    success:  (data) => {
                        them.getUserTimetracks();
                        them.showFinishTimetrackItem = false;
                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            },
            getNow() {
                const today = new Date();

                return today.getDate()+'.'+(today.getMonth()+1)+'.'+today.getFullYear();
            }
        }
    }
</script>
